function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownCheckboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.335 161.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 151.411,
    height: 151.411,
    x: 4.962,
    y: 4.962,
    ry: 12.603,
    style: {
      fill: "var(--surface-contrast-low)",
      fillOpacity: 1,
      stroke: "var(--stroke-contrast-mid)",
      strokeWidth: 9.924,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.064 86.33 21.162 21.885 55.58-54.26",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "var(--text-contrast-high)",
      strokeWidth: 9.89986,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownCheckboxOn);
export default __webpack_public_path__ + "static/media/drop-down-checkbox-on.84121efb450091ef6e369748cdcca17c.svg";
export { ForwardRef as ReactComponent };